import React from "react";

import { ScheduleAStatus } from "mappers";

const ScheduleAOption = option => {
	const notAvailable = option?.status === ScheduleAStatus.UNAVAILABLE;

	if (!option) {
		return null;
	} else if (option.value && notAvailable) {
		return <i>{option.name} (Inactive)</i>;
	} else {
		return option.name;
	}
};

export default ScheduleAOption;
